<template lang="pug">
#modelColor
  .appTools
    .level
      span 设置颜色:
      el-color-picker(@change="colorCheck",popper-class="popperClass",size="mini" v-model='color')
    .level
      el-checkbox(v-model="restore",size="mini" @change="restoreColor") 恢复颜色
    i.el-icon-minus.close(title="最小化",@click="closeAdd")
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      componentColorFuncList: [
        { name: "设置颜色", query: "select" },
        { name: "恢复颜色", query: "clear" }
      ],
      color: '#FFFFFF',
      restore: false
    };
  },
  methods: {
    colorChange(item) {
      switch (item.query) {
        case "select":
          this.$refs.elColorPicker.showPicker = true;
          break;
        case "clear":
          mongeApiMlib.resetElementColor();
          break;
      }
    },
    async colorCheck(val) {
      mongeApiMlib.setElementColor(val);
      this.restore = false;
    },
    restoreColor(val) {
      if (val) {
        mongeApiMlib.resetElementColor();
        this.color = '#FFFFFF';
        setTimeout(() => {
          this.restore = false;
        }, 1000);
      } else {
        mongeApiMlib.setElementColor(this.color);
      }
    },
    closeAdd() {
      this.$emit("closeCom", 'componentColor', true);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
.appTools{
  width: 240px;
  left: calc(50% - 110px);
}
// .mList{
//   position: absolute;
//   bottom: 95px;
//   left: calc(50% - 60px);
//   width: 114px;
//   height: 90px;
//   background: rgba(255, 255, 255, 0.9);
//   border-radius: 4px;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-around;
//   padding: 10px 0;
//   z-index: 4;
//   .item:hover{
//     background: rgba(56, 115, 254, 0.18);
//   }
//   .item{
//     display: flex;
//     align-items: center;
//     height: 38px;
//     width: 100%;
//     justify-content: center;
//     cursor: pointer;
//     span{
//       margin-left: 5px;
//     }
//   }
// }
// .colorPicker{
//   position: absolute;
//   right: 10px;
//   bottom: 55px;
// }
</style>
<style lang="scss">
.popperClass .el-color-dropdown__link-btn{
  display: none;
}
</style>
